// ImagenProducto.js — P3-9b (remate). <img> responsiva ÚNICA para fotos de producto.
// Centraliza el patrón que estrenó el mosaico del Catálogo (srcset medium/medium_large
// + sizes + lazy) para que POS, Inventario, Pedidos, Recompra y cualquier pantalla con
// foto de producto dejen de servir la miniatura 150×150 pixelada.
//
// (≠ FotoProducto.js, que es la foto-SNAPSHOT del Resumen con respaldo Photon.)
//
// El caller SIGUE decidiendo el hueco vacío (su placeholder "SH"/ícono) con su propio
// `src ? <ImagenProducto/> : <ph/>`; acá solo se arma la <img> y, si la carga falla, se
// cae a un placeholder de marca del tamaño pedido (sin red externa).
import React, { useState } from 'react';
import { propsFotoResponsiva } from '../utils/imagenResponsiva';
import { productPlaceholder } from '../utils/productPlaceholder';

export default function ImagenProducto({
  src, srcset = '', sizes = 'miniatura', prioridad = false,
  alt = '', className, phWidth = 64, phHeight, ...rest
}) {
  const [fallo, setFallo] = useState(false);
  if (!src || fallo) {
    return <img className={className} src={productPlaceholder(phWidth, phHeight)} alt={alt} loading={prioridad ? 'eager' : 'lazy'} {...rest} />;
  }
  const props = propsFotoResponsiva({ src, srcset, sizes, prioridad });
  return <img {...props} className={className} alt={alt} onError={() => setFallo(true)} {...rest} />;
}
